import { Routes } from '@angular/router';
import { BookAppointmentComponent } from './book-appointment/book-appointment.component';
import { VehicleInfoComponent } from './appointment/vehicle-info/vehicle-info.component';
import { OverviewComponent } from './appointment/overview/overview.component';
import { CustomerInfoComponent } from './appointment/customer-info/customer-info.component';
import { DealerLocationComponent } from './dealer-location/dealer-location.component';
import { ServiceAppointmentDetailsComponent } from './service-appointment-details/service-appointment-details.component';
import { AppointmentComponent } from './appointment/appointment/appointment.component';
import { ServicesComponent } from './appointment/services/services.component';
import { SplashComponent } from './splash/splash.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'splash',
    component: SplashComponent
  },
  {
    path: 'locations',
    component: DealerLocationComponent
  },
  {
    path: 'getAppointment',
    component: ServiceAppointmentDetailsComponent
  },
  {
    path: 'book-appointment',
    component: BookAppointmentComponent,
    canActivate: [authGuard], 
    children: [
      {
        path: 'vehicle-info',
        component: VehicleInfoComponent,
        canActivate: [authGuard] 
      },
      {
        path: 'service',
        component: ServicesComponent,
        canActivate: [authGuard]
      },
      {
        path: 'appointment',
        component: AppointmentComponent,
        canActivate: [authGuard]
      },
      {
        path: 'customer-info',
        component: CustomerInfoComponent,
        canActivate: [authGuard]
      },
      {
        path: 'overview',
        component: OverviewComponent,
        canActivate: [authGuard]
      },
    ]
  },
  {
    path: 'confirmation',
    component: OverviewComponent,
    canActivate: [authGuard]
  },
  {
    path: 'cancel',
    component: ServiceAppointmentDetailsComponent,
    canActivate: [authGuard]
  },
  {
    path: '',
    redirectTo: 'locations',
    pathMatch: 'full'
  },
];
